export default "__VITE_ASSET__BwAOVPXc__"